module.exports = "/_next/static/images/Example-1d6c02808aee033b6cb10676f192aa5a.svg";